<template>
  <ion-content class="ion-padding">
    <Teleport defer to="ion-app">
      <ion-modal
        ref="modal"
        :swipe-to-close="false"
        :can-dismiss="true"
        :initial-breakpoint="1"
        :breakpoints="[0, 1]"
        @didDismiss="closeModal"
        @ion-breakpoint-did-change="closeModal"
        class="modal-100-height"
      >
        <ion-content class="ion-padding overflow-hidden" :scroll-y="false" :scroll-x="false">
          <div
            class="flex flex-col gap-8 items-center justify-center h-full text-center overflow-hidden"
            style="overflow-y: hidden !important; overflow-x: hidden !important"
          >
            <img :src="statusImage" alt="Top Image" class="w-32 h-32 mb-1 mt-1" />
            <div v-if="egiroTransactionStatus === 'PENDING'">
              <div v-if="recurringGivingSelect === 'One-Time'">
                <div
                  class="text-[1.5rem] md:text-[2.25rem] lg:text-[2.5rem] leading-[2.0625rem] md:leading-[2.75rem] lg:leading-[3rem] font-black text-[#2B2926] tracking-[-0.03em]"
                >
                  Pending
                </div>
                <div
                  class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[2.0625rem] md:leading-[2.25rem] lg:leading-[2.5rem] text-[#2B2926]"
                >
                  We will notify when your payment goes through..
                </div>
              </div>
            </div>

            <div v-if="egiroTransactionStatus === 'SUCCESS'">
              <div v-if="recurringGivingSelect === 'One-Time'">
                <div
                  class="text-[1.5rem] md:text-[2.25rem] lg:text-[2.5rem] leading-[2.0625rem] md:leading-[2.75rem] lg:leading-[3rem] font-black text-[#2B2926] tracking-[-0.03em]"
                >
                  Successful
                </div>
                <div
                  class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[2.0625rem] md:leading-[2.25rem] lg:leading-[2.5rem] text-[#2B2926]"
                >
                  {{ CurrentTime }}
                </div>
              </div>
              <div v-else>
                <div v-if="editMode" class="justfiy-center">
                  <div>
                    <h1
                      class="text-[2.5rem] md:text-[3.25rem] lg:text-[3.5rem] leading-[2.75rem] md:leading-[3.75rem] lg:leading-[4rem] font-black text-[#2B2926] tracking-[-1.2px]"
                    >
                      Request is being<br />processed
                    </h1>
                  </div>
                  <div
                    class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[2.0625rem] md:leading-[2.375rem] lg:leading-[2.5rem] text-[#2B2926] mt-[24px] px-[16px]"
                  >
                    <p v-if="updateAction" class="text-center leading-tight">
                      Changes made to recurring giving will be<br />
                      updated in <span class="font-semibold text-[#1C1C1C]">Manage My Giving</span>.
                      We'll notify <br />
                      you in 1 working day when it's<br />
                      completed.
                    </p>
                    <p v-else class="text-center leading-tight">
                      Recurring giving will be removed from<br />
                      <span class="font-semibold text-[#1C1C1C]">Manage My Giving</span>. We'll
                      notify you in 1<br />working day when it's completed.
                    </p>
                    <p class="mt-[16px] text-center leading-tight">
                      For any queries, you may reach out to
                      <a
                        href="mailto:accounts@heartofgodchurch.org"
                        class="text-[#4F46E5] underline underline-offset-4 font-medium hover:opacity-80"
                        >accounts@heartofgodchurch.org</a
                      >
                    </p>
                  </div>
                </div>
                <div v-else>
                  <div
                    class="text-[2.25rem] md:text-[3.25rem] lg:text-[3.5rem] leading-[2.5rem] md:leading-[3.75rem] lg:leading-[4rem] font-black text-[#2B2926] tracking-[-0.03em]"
                  >
                    <h1>Your application's<br />on the way</h1>
                  </div>
                  <div
                    class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[2.0625rem] md:leading-[2.375rem] lg:leading-[2.5rem] text-[#2B2926] mt-[24px] px-[16px]"
                  >
                    <p class="text-center leading-tight">
                      Your bank is processing it now.<br />Check
                      <span class="font-semibold text-[#1C1C1C]">Manage My Giving</span> in 1
                      working<br />day's time for the status.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="egiroTransactionStatus === 'FAILED'">
              <div v-if="recurringGivingSelect === 'One-Time'">
                <div
                  v-if="errorTitle"
                  class="text-[1.5rem] md:text-[2.25rem] lg:text-[2.5rem] leading-[2rem] md:leading-[2.75rem] lg:leading-[3rem] font-bold text-[#21201E] text-center mb-[8px]"
                >
                  {{ errorTitle }}
                </div>
                <div
                  v-if="errorSubtitle"
                  class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#2B2926] text-center mb-[24px]"
                >
                  {{ errorSubtitle }}
                </div>
                <div
                  class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#2B2926] text-center mb-[8px]"
                >
                  Error Code: {{ errorCode || 'N/A' }}
                </div>
                <div
                  class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#2B2926] text-center mb-[8px]"
                >
                  Transaction ID: {{ transactionId || 'N/A' }}
                </div>
                <div
                  class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#2B2926] text-center mb-[24px]"
                >
                  {{ CurrentTime }}
                </div>
              </div>
              <div v-else>
                <div
                  class="text-[2.25rem] md:text-[3.25rem] lg:text-[3.5rem] leading-[2.0625rem] md:leading-[3.75rem] lg:leading-[4rem] font-black text-[#2B2926] tracking-[-0.03em]"
                >
                  Setup failed
                </div>
                <div
                  class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.375rem] lg:leading-[2.5rem] text-[#2B2926] mt-[24px] px-[16px] text-center"
                >
                  <p>We were not able to setup recurring giving for the selected bank account.</p>
                  <p class="mt-[8px]">Try again now, or go to MyGiving to set it up later.</p>
                </div>
              </div>
            </div>

            <div
              v-if="recurringGivingSelect === 'One-Time' && egiroTransactionStatus !== 'FAILED'"
              class="grid grid-rows-5 grid-cols-2 gap-2"
            >
              <div
                class="bg-blue-200 text-left text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem]"
              >
                Amount given in SGD
              </div>
              <div
                class="bg-blue-300 text-right font-bold text-[1rem] md:text-[1.75rem] lg:text-[1.875rem]"
              >
                {{ transactionDetails.amount }}
              </div>
              <div
                class="bg-blue-200 text-left text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem]"
              >
                Frequency
              </div>
              <div
                class="bg-blue-300 text-right font-bold text-[1rem] md:text-[1.75rem] lg:text-[1.875rem]"
              >
                {{ transactionDetails.frequency }}
              </div>
              <div
                class="bg-blue-200 text-left text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem]"
              >
                Month
              </div>
              <div
                class="bg-blue-300 text-right font-bold text-[1rem] md:text-[1.75rem] lg:text-[1.875rem]"
              >
                {{ transactionDetails.month }}
              </div>
              <div
                class="bg-blue-200 text-left text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem]"
              >
                Giving to
              </div>
              <div
                class="bg-blue-300 text-right font-bold text-[1rem] md:text-[1.75rem] lg:text-[1.875rem]"
              >
                {{ transactionDetails.givingto }}
              </div>
              <div
                class="bg-blue-200 text-left text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem]"
              >
                Giving method
              </div>
              <div
                class="bg-blue-300 text-right font-bold text-[1rem] md:text-[1.75rem] lg:text-[1.875rem]"
              >
                {{ transactionDetails.givingmethod }}
              </div>
            </div>

            <div
              v-if="editMode && updateAction"
              class="absolute bottom-[116px] w-[90%] max-w-[600px] mx-auto left-1/2 -translate-x-1/2 z-10"
            >
              <button
                type="button"
                class="w-full border-[2px] border-[#42362B] rounded-[100px] px-[24px] py-[16px] md:py-[20px] lg:py-[22px] text-center cursor-pointer bg-transparent text-[#21201E] text-[1rem] md:text-[1.25rem] lg:text-[1.375rem] font-bold"
                @click="goToCheckStatus"
              >
                Check Status
              </button>
            </div>

            <div
              v-else-if="editMode && !updateAction"
              class="absolute bottom-[116px] w-[90%] max-w-[600px] mx-auto left-1/2 -translate-x-1/2 z-10"
            >
              <button
                type="button"
                class="w-full border-[2px] border-[#42362B] rounded-[100px] px-[24px] py-[16px] md:py-[20px] lg:py-[22px] text-center cursor-pointer bg-transparent text-[#21201E] text-[1rem] md:text-[1.25rem] lg:text-[1.375rem] font-bold"
                @click="goToCheckStatus"
              >
                See Status
              </button>
            </div>

            <div
              class="absolute bottom-[44px] w-[90%] max-w-[600px] mx-auto left-1/2 -translate-x-1/2 z-10"
            >
              <button
                type="button"
                id="generate-qr-code"
                class="w-full mb-[0] bg-[#42362B] text-white font-semibold rounded-[100px] py-[16px] md:py-[20px] lg:py-[22px] text-[1.125rem] md:text-[1.375rem] lg:text-[1.5rem] text-center"
                @click="handleNext"
              >
                Back to MyGiving
              </button>
            </div>
          </div>
        </ion-content>
      </ion-modal>
    </Teleport>
  </ion-content>
</template>

<script>
import { ERROR_STATE_MAP } from '@/constants/MyGiving/ERROR_STATES';
import { IonModal, IonContent } from '@ionic/vue';

export default {
  components: {
    IonModal,
    IonContent,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    egiroTransactionStatus: {
      type: String,
      default: 'PENDING',
      validator: value => ['SUCCESS', 'FAILED', 'PENDING'].includes(value),
    },
    transactionDetails: {
      type: Object,
      default: () => ({}),
    },
    recurringGivingSelect: {
      type: String,
      default: null,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    updateAction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ACTION_MAP: {
        CONTACT_SUPPORT: {
          title: 'Your transaction could not be completed 🥲',
          subtitle: 'Please contact support for help!',
        },
        TRY_AGAIN: {
          title: 'That took longer than expected.',
          subtitle: "Let's try that again!",
        },
        TRY_AGAIN_LATER: {
          title: 'Oops, something went wrong 😅',
          subtitle: 'Please try again in a moment!',
        },
        TRY_AGAIN_TOMORROW: {
          title: "You've reached today's transaction limit",
          subtitle: 'Please try again tomorrow!',
        },
        UNLINK_AND_LINK_ACCOUNT: {
          title: 'Your transaction could not be completed 🥲',
          subtitle:
            'This could be due to a bank account issue. Unlink and re-link your account, then try again.',
        },
      },
      ERROR_ACTION_IMAGE_MAP: {
        CONTACT_SUPPORT: 'contact-support.svg',
        TRY_AGAIN: 'try-again.svg',
        TRY_AGAIN_LATER: 'try-again-later.svg',
        TRY_AGAIN_TOMORROW: 'try-again-tomorrow.svg',
        UNLINK_AND_LINK_ACCOUNT: 'contact-support.svg',
      },
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.$refs.modal?.$el?.present();
      } else {
        this.$refs.modal?.$el?.dismiss();
      }
    },
  },
  mounted() {
    if (this.isOpen) {
      this.$nextTick(() => this.$refs.modal?.$el?.present());
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    async handleNext() {
      // Navigate first to avoid showing blank form
      this.$emit('navigate', { path: '/my-giving' });
      // Then close modal after navigation starts
      await this.dismissModalThenEmitClose();
    },
    async goToCheckStatus() {
      // Navigate first to avoid showing blank form
      this.$emit('navigate', { path: '/my-giving/manage' });
      // Then close modal after navigation starts
      await this.dismissModalThenEmitClose();
    },
    async dismissModalThenEmitClose() {
      if (this.$refs.modal?.$el?.dismiss) {
        try {
          await this.$refs.modal?.$el?.dismiss();
        } catch (e) {
          console.warn('[SuccessModal] Error dismissing modal:', e);
        }
        await new Promise(r => setTimeout(r, 100));
      }
      this.$emit('close');
    },
  },
  computed: {
    statusImage() {
      if (this.egiroTransactionStatus === 'FAILED') {
        // Check if errorAction exists and map to corresponding SVG
        if (this.errorAction && this.ERROR_ACTION_IMAGE_MAP[this.errorAction]) {
          const svgFile = this.ERROR_ACTION_IMAGE_MAP[this.errorAction];
          return `/assets/icons/my-giving/${svgFile}`;
        }
        // Fallback to default failure image
        return '/assets/images/my-giving/rcfail.png';
      }

      // SUCCESS and PENDING show the same artwork.
      const imageFile =
        this.recurringGivingSelect === 'One-Time' ? 'transaction-success.png' : 'rcsuccess.png';

      return `/assets/images/my-giving/${imageFile}`;
    },
    CurrentTime() {
      if (!this.transactionDetails?.transactionTime) {
        return '';
      }
      const date = new Date(this.transactionDetails.transactionTime);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        return '';
      }

      const datePart = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });

      const timePart = date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });

      return `${datePart}, ${timePart}`;
    },
    errorCode() {
      if (!this.transactionDetails?.transactionMessage) {
        return null;
      }
      const message = this.transactionDetails.transactionMessage;
      const match = message.match(/errorCode:\s*([A-Z0-9_/]+)/i);
      return match ? match[1] : null;
    },
    errorAction() {
      if (!this.errorCode) {
        return null;
      }
      // Try string key first
      let action = ERROR_STATE_MAP[this.errorCode];
      // If not found and errorCode is numeric, try as number
      if (!action && /^\d+$/.test(this.errorCode)) {
        action = ERROR_STATE_MAP[Number(this.errorCode)];
      }
      return action || null;
    },
    errorTitle() {
      if (!this.errorAction || !this.ACTION_MAP[this.errorAction]) {
        return null;
      }
      return this.ACTION_MAP[this.errorAction].title;
    },
    errorSubtitle() {
      if (!this.errorAction || !this.ACTION_MAP[this.errorAction]) {
        return null;
      }
      return this.ACTION_MAP[this.errorAction].subtitle;
    },
    transactionId() {
      // If explicitly set to 'N/A' in transactionDetails, return it
      if (this.transactionDetails?.transactionId === 'N/A') {
        return 'N/A';
      }
      // Try to get from route params first
      if (this.$route?.params?.transactionId) {
        return this.$route.params.transactionId;
      }
      // Try to get from transactionDetails
      if (this.transactionDetails?.transactionId) {
        return this.transactionDetails.transactionId;
      }
      if (this.transactionDetails?.id) {
        return this.transactionDetails.id;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.modal-100-height {
  --height: 100vh;
  --border-radius: 24px 24px 0 0;
  --box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  fill: rgba(93, 93, 93, 0.6);
  align-items: flex-end !important;
  transition: all 0.8s ease-in-out !important;
}

.modal-wrapper {
  transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  overflow: hidden !important;
}

ion-content {
  --background: #f6f4f0;
  overflow: hidden !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}

.modal-100-height::part(handle) {
  display: none;
}

::v-deep ion-content {
  overflow: hidden !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}
</style>
